/** Static SVG preview of a ball skin + its googly face (used by the picker). */
import type { Skin } from '../game/skins';
import { toHex } from '../game/skins';

export function SkinPreview({ skin, className }: { skin: Skin; className?: string }) {
  return (
    <svg viewBox="0 0 100 100" className={className} role="img" aria-hidden="true">
      <circle cx="50" cy="50" r="49" fill={toHex(skin.rim)} />
      <circle cx="50" cy="50" r="44" fill={toHex(skin.body)} />
      <circle cx="40" cy="36" r="6" fill={toHex(skin.highlight)} opacity="0.5" />
      {/* eye-whites (spaced apart) */}
      <circle cx="32" cy="44" r="14" fill={toHex(skin.sclera)} />
      <circle cx="68" cy="44" r="14" fill={toHex(skin.sclera)} />
      {/* pupils (looking in different directions = googly) */}
      <circle cx="36" cy="48" r="6" fill={toHex(skin.pupil)} />
      <circle cx="64" cy="40" r="6" fill={toHex(skin.pupil)} />
      {/* open, worried mouth */}
      <ellipse cx="50" cy="73" rx="13" ry="11" fill={toHex(skin.mouth)} />
    </svg>
  );
}
